<template>
  <v-card class="rounded-lg white">
    <v-card-title class="secondary--text">
      <v-icon class="ml-2" color="primary">fa-pallet</v-icon>
      {{title}}</v-card-title
    >

    <v-card-text>
      <v-row>
        <v-col cols="12" md="3">
          <ware-select
            :show-info="!passed_ware"
            label="نام کالا"
            v-model="inventory.ware"
            type="wares"
            :disabled="passed_ware != null"
            :showMainUnit="false"
            @mainUnitName="(e) => (inventory.mainUnitName = e)"
          />
        </v-col>
        <v-col cols="12" md="2">
          <ware-select
            :show-info="false"
            label="کد کالا"
            with-code="true"
            v-model="inventory.ware"
            type="wares"
            :disabled="passed_ware != null"
            :showMainUnit="false"
            @mainUnitName="(e) => (inventory.mainUnitName = e)"
          />
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field
            class="rounded-lg"
            disabled
            label="واحد"
            :value="inventory.mainUnitName"
            background-color="white"
          />
        </v-col>

        <v-col cols="12" md="3">
          <warehouse-select
            class="rounded-lg"
            :return-object="false"
            label="انبار"
            :items="warehouses"
            v-model="filter_warehouses"
            item-text="title"
            item-value="id"
            multiple
            clearable
            @input="setFilterWithWarehouses"
          >
          </warehouse-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch inset label="نمایش فی مرکب" v-model="showComplexFees"></v-switch>
          <v-switch inset label="نمایش انبار" v-model="showWarehouses"></v-switch>
        </v-col>

        <v-col cols="12" md="2" class="d-flex justify-center justify-md-end">
          <sort-inventory :datatable="$refs.datatable" />
        </v-col>

        <v-col cols="12" class="detailed-ware-inventory">
          <m-datatable
            :show-filter-row="false"
            v-if="inventory.ware"
            :api-url="url"
            :headers="headers"
            :filters.sync="filters"
            :item-class="getItemClass"
            ref="datatable"
            :hide-default-header="true"
            :showSelect="false"
          >
            <template #header="{ props: { headers } }">
              <thead id="custom-header">
                <tr>
                  <th rowspan="2">#</th>
                  <th rowspan="2">تاریخ</th>
                  <th rowspan="2">نوع عملیات</th>
                  <th rowspan="2">شماره</th>
                  <th rowspan="2">شرح فاکتور</th>
                  <th rowspan="2">نام حساب</th>

                  <th colspan="3">وارده</th>
                  <th colspan="3" class="border-right">صادره</th>
                  <th colspan="3" class="border-right">مانده</th>

                  <th rowspan="2" v-if="showWarehouses">انبار</th>
                </tr>
                <tr id="secondary-header">
                  <th class="border-right">مقدار</th>
                  <th>فی</th>
                  <th>مبلغ</th>

                  <th class="border-right">مقدار</th>
                  <th>فی</th>
                  <th>مبلغ</th>

                  <th>مقدار</th>
                  <th>فی</th>
                  <th>مبلغ</th>
                </tr>
              </thead>
            </template>

            <template #item.factor.code="{ item }">
              <v-btn v-if="item.factor.code >= 0" text depressed color="info" icon rounded :to="getDetailLink(item)"
                >{{ item.origin.code }}
              </v-btn>
              <v-btn v-else text depressed color="info" icon rounded @click="getToFpi(item)"
                >{{ item.factor.id }}
              </v-btn>
            </template>

            <template #item.inputFee="{ item }">
              <Fee :fees="item.input.fee" :show-complex-fees="showComplexFees" />
            </template>

            <template #item.outputFee="{ item }">
              <Fee :fees="item.output.fee" :show-complex-fees="showComplexFees" />
            </template>
            <template #item.remain.count="{ item }">
              <span :class="(item.remain.count < 0)?'danger--text':'black--text'">
                {{ item.remain.count | toMoney }}
              </span>
            </template>
            <template #item.remainFee="{ item }">
              <span class="black--text">
                <Fee :fees="item.remain.fee" :show-complex-fees="showComplexFees" :warehouses="filter_warehouses"/>
              </span>
            </template>
            <template #item.remain.value="{ item }">
              <span :class="(item.remain.count < 0)?'danger--text':'black--text'">
                {{ item.remain.value | toMoney }}
              </span>
            </template>

            <template #item.warehouse="{ item }">
              <v-row no-gutters v-if="showWarehouses && item.remain">
                <v-col cols="12" dir="ltr" v-for="f in getWarehousesRemains(item)" class="text-right">
                  {{ f.name }} x {{ f.count | toMoney }}
                </v-col>
              </v-row>
              <span v-else> - </span>
            </template>
          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>
    <v-row justify="center">
      <v-dialog
        v-model="notice_dialog"
        persistent
        @click:outside="notice_dialog = false"
        max-width="400"
        class="rounded-lg"
      >
        <v-card class="rounded-lg pa-2">
          <v-card-title class="error--text text-h5"> توجه! </v-card-title>
          <v-card-text>
            <v-row class="mt-5 mr-5">
              با توجه به ادواری بودن سیستم انبار، جهت مشاهده مبلغ صحیح مانده،روی دکمه مرتب سازی کلیک کنید
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="notice_dialog = false"> بستن </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>

<script>
import _ from "lodash";
import queryBinding from "@/components/m-query-binding";
import wareApiMixin from "@/mixin/wareApi";
import Template from "@/views/Template.vue";
import SortInventory from "./SortInventory.vue";
import Fee from "./Fee.vue";
import OpenInventoryBtn from "@/components/btns/OpenInventoryBtn";
import WarehouseSelect from "@/components/selects/WarehouseSelect.vue";

export default {
  components: { Template, SortInventory, Fee, OpenInventoryBtn, WarehouseSelect },
  mixins: [queryBinding, wareApiMixin],
  props: {
    passed_ware: {
      default: null,
    },
  },
  data() {
    return {
      notice_dialog: false,
      filter_warehouses: [0],
      showComplexFees: false,
      showWarehouses: false,

      url: "reports/inventory/ware",
      inventory: {
        ware: null,
        mainUnitName: null,
      },
      filters: {
        ware: null,
      },
    };
  },
  computed: {
    title(){
      return this.setDocumentTitle('کاردکس کالا')
    },
    headers() {
      let headers = [
        {
          text: "تاریخ",
          value: "factor.date",
          type: "date",
          sortable: false,
        },
        {
          text: "نوع عملیات",
          value: "factor.type",
          type: "select",
          sortable: false,
          items: [
            {
              text: "موجودی اول دوره",
              value: "fpi",
            },
            {
              text: "خرید",
              value: "buy",
            },
            {
              text: "برگشت از خرید",
              value: "backFromBuy",
            },
            {
              text: "فروش",
              value: "sale",
            },
            {
              text: "برگشت از فروش",
              value: "backFromSale",
            },
            {
              text: "وارده از انتقال",
              value: "it",
            },
            {
              text: "صادره با انتقال",
              value: "ot",
            },
            {
              text: "حواله کالای مصرفی",
              value: "cw",
            },
            {
              text: "رسید تعدیل انبار",
              value: "ia",
            },
            {
              text: "حواله تعدیل انبار",
              value: "oa",
            },
            {
              text: "رسید تعدیل انبارگردانی",
              value: "wia",
            },
            {
              text: "حواله تعدیل انبارگردانی",
              value: "woa",
            },
          ],
        },
        {
          text: "شماره",
          value: "factor.code",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "شرح فاکتور",
          value: "factor.explanation",
          type: "text",
          sortable: false,
          filterable: false,
        },
        {
          text: "نام حساب",
          value: "factor.account.name",
          type: "text",
          sortable: false,
          filterable: false,
          leftBorder: true,
        },
        {
          text: "مقدار وارده",
          value: "input.count",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "فی وارده",
          value: "inputFee",
          type: "numeric",
          sortable: false,
          filters: [],
          filterable: false,
          hideInExport: true,
        },
        {
          text: "فی وارده",
          value: "input.fee",
          show: false,
          type: "fee",
        },
        {
          text: "مبلغ وارده",
          value: "input.value",
          type: "numeric",
          sortable: false,
          filterable: false,
          filters: [],
        },
        {
          text: "مقدار صادره",
          value: "output.count",
          type: "numeric",
          sortable: false,
          filterable: false,
          filters: [],
        },
        {
          text: "فی صادره",
          value: "outputFee",
          type: "numeric",
          sortable: false,
          filterable: false,
          filters: [],
          hideInExport: true,
        },
        {
          text: "فی صادره",
          value: "output.fee",
          show: false,
          type: "fee",
        },
        {
          text: "مبلغ صادره",
          value: "output.value",
          type: "numeric",
          sortable: false,
          filterable: false,
          filters: [],
        },
        {
          text: "مقدار مانده",
          value: "remain.count",
          type: "numeric",
          sortable: false,
          filterable: false,
          filters: [],
        },
        {
          text: "فی مانده",
          value: "remainFee",
          type: "numeric",
          sortable: false,
          filterable: false,
          filters: [],
          hideInExport: true,
        },
        {
          text: "فی مانده",
          value: "remain.fee",
          show: false,
          type: "fee",
        },
        {
          text: "مبلغ مانده",
          value: "remain.value",
          type: "numeric",
          sortable: false,
          filterable: false,
          filters: [],
        },
      ];

      if (this.showWarehouses) {
        headers.push({
          text: "انبار",
          value: "warehouse",
          type: "numeric",
        });
      }

      return headers;
    },
    wares() {
      return this.$store.state.wares.wares;
    },
  },
  watch: {
    passed_ware() {
      this.inventory.ware = this.passed_ware;
    },
    "inventory.ware": {
      handler() {
        if (this.inventory.ware) {
          this.filters.ware = this.inventory.ware.id;
        }
      },
      deep: true,
    },
  },
  created() {
    this.getWarehouses(undefined);
    if (this.passed_ware) {
      this.inventory.ware = this.passed_ware;
    }
  },
  mounted() {
    if (this.financialYear.warehouse_system == "a" && !this.financialYear.are_factors_sorted) {
      this.notice_dialog = true;
    }
  },
  methods: {
    getWarehousesRemains(item) {
      if (!item.remain_fees) return [];
      let remains = {};
      item.remain_fees.forEach((fee) => {
        remains[fee.warehouse] = 0;
      });
      item.remain_fees.forEach((fee) => {
        remains[fee.warehouse] += fee.count;
      });

      console.log(remains);

      let warehouseRemains = [];
      Object.keys(remains).forEach((key) => {
        if (remains[key] != 0) {
          warehouseRemains.push({
            name: this.warehouses.find((o) => o.id == key).name,
            count: remains[key],
          });
        }
      });

      return warehouseRemains;
    },
    getItemClass(item) {
      if (["backFromBuy", "backFromSale"].includes(item.factor.type)) {
        return "back-factor";
      }
      return "";
    },
    setFilterWithWarehouses(inventoryWare) {
      let warehouses_string = this.filter_warehouses.join(",");
      if (warehouses_string != "0") {
        this.filters.warehouse_in = warehouses_string;
      } else {
        this.filters.warehouse_in = undefined;
      }
      this.$refs.datatable && this.$refs.datatable.getDataFromApi();
    },
    getDetailLink(item) {
      let factor = item.factor;
      let type = factor.type;
      let origin = item.origin;
      if (["it", "ot"].includes(type)) {
        return {
          name: "TransferForm",
          params: {
            id: origin.id,
          },
        };
      } else if (["ia", "oa"].includes(type)) {
        return {
          name: "AdjustmentForm",
          params: {
            type: type,
            id: origin.id,
          },
        };
      }

      return {
        name: "FactorForm",
        params: {
          id: origin.id,
          type: origin.type,
          isPreFactor: factor.is_pre_factor,
        },
      };
    },
    getToFpi(item) {
      this.$router.push("/panel/factor/form/false/fpi/" + item.factor.id);
    },
  },
};
</script>

<style lang="scss">
$border: 1px solid #e0e0e0 !important;
.detailed-ware-inventory div.v-data-table__wrapper table tr {
  td,
  th {
    &:nth-child(7),
    &:nth-child(10),
    &:nth-child(13),
    &:nth-child(16) {
      border-right: $border;
    }
  }
}
.back-factor {
  color: #a61a14 !important;
}
#secondary-header {
  th {
    top: 0 !important;
  }
}
.border-right {
  border-right: $border;
}
#custom-header th {
  text-align: center !important;
  color: #212121 !important;
}
</style>
